import { createSelector } from '@ngrx/store';
import { getOnlineOrderRecalcData } from '../../../onlineOrder/selectors/getOnlineOrderRecalcData';
import { getOrderSummary } from '../../../onlineOrder/selectors/getOrderSummary';
import { getMemberRedeemableePoints } from '../../../members/selectors/getMemberRedeemablePointsTotal';
import { isPayByPointsSelected } from '../../../creditCards/selectors/isPayByPointsSelected';
import { getLocationRedemptionRate } from '../../getLocationRedemptionRate';

export const canFulfillPaymentWithPointsOnly = createSelector(
    getOrderSummary,
    isPayByPointsSelected,
    getMemberRedeemableePoints,
    getLocationRedemptionRate,
    getOnlineOrderRecalcData,
    (orderSummary, payByPointsSelected, points, locationRedemptionRate, recalculate) => {
        const total = orderSummary?.Total || 0;
        const availableBalance = points / locationRedemptionRate?.rate;
        const areAllProductsRedeemable = recalculate?.data?.Items?.every((item) => item.PointsCost !== null);

        return payByPointsSelected && areAllProductsRedeemable && availableBalance >= total;
    },
);
